// classificationLevels.js
// Select options for classification and control markings.
// Colors are sourced from the official US classification banner color
// codes defined in theme/classificationColors.js — do not hardcode colors
// here; update that module instead.

import {CLASSIFICATION_COLORS} from '../../../theme/classificationColors';

// Order matters: rank is derived from array index (see documentClassification.js
// getClassificationRank), and must match dash-api's ClassificationLevel enum
// (U=0, C=1, S=2, TS=3).
export const CLASSIFICATION_LEVELS = [
    {
        value: 'U',
        label: 'U - Unclassified',
        color: CLASSIFICATION_COLORS.U.main,
        bgColor: CLASSIFICATION_COLORS.U.bg,
    },
    {
        value: 'C',
        label: 'C - Confidential',
        color: CLASSIFICATION_COLORS.C.main,
        bgColor: CLASSIFICATION_COLORS.C.bg,
    },
    {
        value: 'S',
        label: 'S - Secret',
        color: CLASSIFICATION_COLORS.S.main,
        bgColor: CLASSIFICATION_COLORS.S.bg,
    },
    {
        value: 'TS',
        label: 'TS - Top Secret',
        color: CLASSIFICATION_COLORS.TS.main,
        bgColor: CLASSIFICATION_COLORS.TS.bg,
    },
];

export const getClassificationLabel = (value) => {
    const level = CLASSIFICATION_LEVELS.find(l => l.value === value);
    return level ? level.label : 'Unknown';
}

export const getClassificationByValue = (value) => {
    return CLASSIFICATION_LEVELS.find(l => l.value === value) || null;
}

